module.exports = __webpack_public_path__ + "img/digitala.dff08fd5.png";